import { my } from './locales/my';

export type UiLocale = 'en' | 'my';
export const UI_LOCALES: readonly UiLocale[] = ['en', 'my'];

// English is the source text, so it needs no dictionary. Add a locale by adding
// its dictionary here and its code to UiLocale / UI_LOCALES.
const dictionaries: Record<Exclude<UiLocale, 'en'>, Record<string, string>> = { my };
const STORAGE_KEY = 'utage.locale';
let currentLocale: UiLocale = 'en';

const isUiLocale = (value: unknown): value is UiLocale => UI_LOCALES.includes(value as UiLocale);
const readStored = (): string | null => { try { return localStorage.getItem(STORAGE_KEY); } catch { return null; } };
const writeStored = (locale: UiLocale): void => { try { localStorage.setItem(STORAGE_KEY, locale); } catch { /* storage can be blocked; the choice still applies for this visit */ } };
const telegramLocale = (): UiLocale | null => {
  const code = String(window.Telegram?.WebApp?.initDataUnsafe?.user?.language_code ?? '').toLowerCase();
  return code === 'my' || code.startsWith('my-') ? 'my' : null;
};
const applyDocumentLocale = (): void => { document.documentElement.lang = currentLocale; };

export const setUiLocale = (locale: UiLocale): void => { currentLocale = isUiLocale(locale) ? locale : 'en'; writeStored(currentLocale); applyDocumentLocale(); };
export const getUiLocale = (): UiLocale => currentLocale;
export const restoreUiLocale = (): UiLocale => {
  const stored = readStored();
  currentLocale = isUiLocale(stored) ? stored : telegramLocale() ?? 'en';
  applyDocumentLocale();
  return currentLocale;
};
export const t = (english: string): string => currentLocale === 'en' ? english : (dictionaries[currentLocale][english] ?? english);
export const tf = (english: string, vars: Record<string, string | number>): string => {
  let out = t(english); for (const [key, value] of Object.entries(vars)) out = out.replaceAll(`{${key}}`, String(value)); return out;
};
